// @ts-ignore
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import PersonalInformation from "./components/multistep/PersonalInformation";
import PaymentDetails from "./components/multistep/PaymentDetails";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import OrderConfirmation from "./components/multistep/OrderConfirmation";
import ChoosePlan from "./components/multistep/ChoosePlan";

type CheckoutWizardProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
};

const CheckoutWizard: React.FC<CheckoutWizardProps> = (props) => {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    if (window.location.hash.startsWith("#payment")) {
      setActiveStep(4);
      setMounted(true);
      setTermsAccepted(false);
    } else {
      setMounted(true);
      setTermsAccepted(false);
    }

    return () => {
      setActiveStep(0);
      setMounted(false);
    };
  }, []);

  const handleComplete = () => {
    console.log("Form completed!");
    // Handle form completion logic here
    let path = `/telco`;
    navigate(path);
  };

  const tabChanged = ({
    prevIndex,
    nextIndex,
  }: {
    prevIndex: number;
    nextIndex: number;
  }) => {};

  const authenticateUser = () => {
    if (props.onApply) {
      props.onApply();
    }
  };

  if (mounted) {
    return (
      <FormWizard
        color={"#df0e0e"}
        onComplete={handleComplete}
        onTabChange={tabChanged}
        startIndex={activeStep}
      >
        <FormWizard.TabContent title="Choose Plan">
          <ChoosePlan />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Personal Information">
          <PersonalInformation
            payload={props.payload}
            authenticateUser={() => authenticateUser()}
            signalIfValid={() => true}
          />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Payment Information">
          <PaymentDetails
            payload={props.payload}
            authenticateUser={() => authenticateUser()}
            signalIfValid={() => true}
          />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Order Confirmation">
          <OrderConfirmation />
        </FormWizard.TabContent>
      </FormWizard>
    );
  }

  return null;
};

export default CheckoutWizard;
